import type {
    ParticipantSampleApiInterface,
    ParticipantSampleInterface,
    ParticipantSampleNotInWorkApiInterface,
    ParticipantSamplePayloadInterface,
} from "./ParticipantSampleTypes";

export function mapWorkingSampleFromApi(sample: ParticipantSampleApiInterface): ParticipantSampleInterface {
    return {
        id: sample.id,
        title: sample.title,
        alias: sample.alias,
        requires_nonstandard_consent: sample.requires_nonstandard_consent,
        can_contain_parts: sample.can_contain_parts,
        sequence: sample.pivot?.sequence ?? 0,
        sent_count: sample.pivot?.sent_count ?? sample.sent_count,
        paid_count: sample.pivot?.paid_count ?? sample.paid_count,
    };
}

export function mapNotInWorkSampleFromApi(sample: ParticipantSampleNotInWorkApiInterface): ParticipantSampleInterface {
    return {
        id: sample.id,
        title: sample.title,
        alias: sample.alias,
        requires_nonstandard_consent: sample.requires_nonstandard_consent,
        can_contain_parts: sample.can_contain_parts,
        sequence: 0,
        sent_count: sample.pivot?.sent_count ?? sample.sent_count,
        paid_count: undefined,
    };
}

export function toWorkingSamplePayload(sample: ParticipantSampleInterface): ParticipantSamplePayloadInterface {
    return {
        ...sample,
        is_payed: true,
    };
}
